<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-03-01 16:33:52
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">投诉列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="投诉人名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入投诉人名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="投诉编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name9"
                    placeholder="请输入投诉编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="投诉人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入投诉人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="被投诉人名">
                  <el-input
                    v-model="ruleForm.name1"
                    placeholder="请输入被投诉人名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="被投诉人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone1"
                    placeholder="请输入被投诉人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择处理状态"
                  >
                    <el-option label="投诉中" value="0"></el-option>
                    <el-option label="已处理" value="1"></el-option>
                    <el-option label="已撤销" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-date-picker
                  v-model="ruleForm.time"
                  type="datetimerange"
                  range-separator="至"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </el-col> -->
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>

      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="单号" align="center">
          </el-table-column>
          <el-table-column
            prop="complainNo"
            label="投诉编号"
            align="center"
            width="210"
          >
          </el-table-column>
          <el-table-column
            prop="jobName"
            label="任务名称"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column prop="complainantName" label="投诉人" align="center">
          </el-table-column>
          <el-table-column label="投诉对象" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.respondentName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="投诉内容" align="center" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.complainMemo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.dutyName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="赔偿金额" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.amendsMoney | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理备注" align="center" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.memo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理人" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">投诉中</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已处理</span
              >
              <span class="blueColor" v-if="scope.row.status == 2">已撤销</span>
            </template>
          </el-table-column>
          <el-table-column label="投诉时间" align="center" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.submitAt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="150"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>
                <div
                  class="operateBtn"
                  @click="handleEdit(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  处理
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <TableScrollSlider :table-ref="$refs.scrollTable" />
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        name9: "",
        phone: "",
        name1: "",
        phone1: "",
        status: "",
        time: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goDetail(val) {
      this.$router.push({
        path: "/complaintAdd",
        query: {
          id: val.id,
          isDetail: 1,
        },
      });
    },
    handleEdit(val) {
      this.$router.push({
        path: "/complaintAdd",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.name9 = "";
      this.ruleForm.phone = "";
      this.ruleForm.name1 = "";
      this.ruleForm.phone1 = "";
      this.ruleForm.status = "";
      this.ruleForm.time = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "complainant_name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.name9 != "") {
        param.queryParams.push({
          name: "complain_no",
          type: "input",
          value: this.ruleForm.name9,
        });
      }
      if (this.ruleForm.name1 != "") {
        param.queryParams.push({
          name: "respondent_name",
          type: "input",
          value: this.ruleForm.name1,
        });
      }
      if (this.ruleForm.phone != "") {
        param.queryParams.push({
          name: "complainant_phone",
          type: "input",
          value: this.ruleForm.phone,
        });
      }
      if (this.ruleForm.phone1 != "") {
        param.queryParams.push({
          name: "respondent_phone",
          type: "input",
          value: this.ruleForm.phone1,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      if (this.ruleForm.time != "") {
        param.queryParams.push({
          name: "submit_at",
          type: "dateRange",
          fromValue: this.ruleForm.time[0],
          toValue: this.ruleForm.time[1],
        });
      }
      this.$axios
        .post(`/admapi/complain/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
